import { StateService } from '@uirouter/angular';

import { Injectable } from '@angular/core';
import { UserService } from '../../../../core/services/core.user.service';
import { TrackerRest } from '../../services/tracker.rest';
import * as _ from 'lodash';

@Injectable()
export class AssigneeHelperService {
  constructor(
    private userService: UserService,
    private trackerRest: TrackerRest,
    private stateService: StateService
  ) {}

  getFilteredAssignees(q: string, tid: number): Promise<any[]> {
    const nobody = [this.userService.constants.nobody];

    if (!tid) {
        tid = _.get(this.stateService.params, 'tracker', 0);
    }

    return this.trackerRest.assignees(tid, q)
    .then((result: any) => {
        return [...nobody, ...(result?.items || [])];
    },
    () => Promise.resolve(nobody));
  }

  assigneeTitle(trackerItem: any, slice: number = 0): string {
    return _.without(
      _.get(trackerItem, 'rel.assignees', []).slice(slice),
      this.userService.isNobody
    )
      .map(this.userService.fullName)
      .join(', ');
  }

  assigneeCount(trackerItem: any): number {
    return _.without(
      _.get(trackerItem, 'rel.assignees', []),
      this.userService.isNobody
    ).length;
  }

  isAssigned(trackerItem: any): boolean {
    return this.assigneeCount(trackerItem) > 0;
  }

  isAssignedTo(trackerItem: any, assignee: any): boolean {
    return _.findIndex(_.get(trackerItem, 'rel.assignees', []), { id: assignee.id }) > -1;
  }

  setAssignee(trackerItem: any, member: any): void {
    if (this.isAssignedTo(trackerItem, member)) {
      _.remove(trackerItem.rel.assignees, { id: member.id });
    } else {
      trackerItem.rel.assignees.push(member);
    }

    if (trackerItem.rel.assignees.length > 1) {
      _.remove(trackerItem.rel.assignees, { id: this.userService.constants.nobody.id });
    }

    if (trackerItem.rel.assignees.length === 0) {
      trackerItem.rel.assignees.push(this.userService.constants.nobody);
    }
  }

  emptyAssignees(trackerItem: any): void {
    trackerItem.rel.assignees = [];
  }

  assignToNobody(trackerItem: any): void {
    trackerItem.rel.assignees = [this.userService.constants.nobody];
  }

  isNobody = this.userService.isNobody;
}
